import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { PlantOptionsState } from './plant-options.state';
import { PlantOptionsInitialState, PlantOptionsLoad } from './plant-options.actions';

@Injectable({ providedIn: 'root' })
export class PlantOptionsFacade implements LoadDataFacade, SetInitialStateFacade {
  options$: Observable<string[]> = this.store.select(PlantOptionsState.getOptions);
  loaded$: Observable<boolean> = this.store.select(PlantOptionsState.getLoaded);

  constructor(private store: Store) {}

  loadAll(filter: string): void {
    this.store.dispatch(new PlantOptionsLoad(filter));
  }

  setInitialState(): void {
    this.store.dispatch(new PlantOptionsInitialState());
  }
}
